export class WorkspaceNotFoundError extends Error {
    constructor() {
        super('Workspace not found');
        this.name = 'WorkspaceNotFoundError';
    }
}

export class WorkspacePermissionError extends Error {
    constructor() {
        super('Permission denied');
        this.name = 'WorkspacePermissionError';
    }
}

export class WorkspaceLoadError extends Error {
    constructor(cause?: unknown) {
        super('Failed to load workspace');
        this.name = 'WorkspaceLoadError';
        if (cause instanceof Error) {
            this.cause = cause;
        }
    }
}
